module.exports = __webpack_public_path__ + "assets/img/32065511c841f21c7fa4bba2fcd58611.svg";